import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Livello_2"
    width={48}
    height={48}
    data-name="Livello 2"
    {...props}
  >
    <defs>
      <style>
        {
          ".cls-12{fill:none;stroke:#a3d8e7;stroke-miterlimit:10;stroke-width:2px}"
        }
      </style>
    </defs>
    <g id="Palette">
      <path
        d="M36 48V24M24 36h24M1 13.32V1h15M1 29.32V47h15M32 1h15v12.32"
        className="cls-12"
      />
    </g>
  </svg>
)
export default SvgComponent
